export const years_data = [
    {
        "year": 2018,
        "food": "Hot Dogs",
        "title": "Humble Beginnings",
        "video": "https://www.youtube.com/embed/0-7L21ZieD8",
        "food_img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/foods/hotdog_resized.png",
        "professional_winner": "Matt Kelly",
        "amateur_winner": "John Akers",
        "event_poster": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/event_posters/Year1Poster.jpg",
        "logo": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/logos/GS1_logo.png",
        "desc": "<orange>June 9th</orange> - In the early afternoon the clouds parted and attendees trickled into a grassy Madison Valley backyard, ready to witness a <orange>hot dog</orange> eating contest called... 'The Gullet Stuffer'. \\n\\n Adorned in sky blue T-Shirts that arrived minutes before start time; a tightly contested (5-minute long) Amateur group saw <orange>John 'Akinator' Akers</orange> narrowly defeat a hard charging Mackenzie 'Gaddyball' Gaddy.\\n\\n There were surely some butterflies for the Professional group before they were introduced in front of an estimated crowd of 50, but once the dogs hit their gullet, all bets were off. After a fiery start, the pace dragged to a crawl for all but one athlete... <orange>Matt 'Bad Belly' Kelly</orange> began working the crowd; keeping at a steady 1 dog-per minute pace before ascending the throne as the first ever Gullet Stuffer Grand Champion.",
        "competitors": [
            {
                "firstName": "Carey",
                "lastName": "Neu",
                "rank": "Amateur",
                "result": 4,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/carey200.png"
            },
            {
                "firstName": "Alea",
                "lastName": "Campbell",
                "rank": "Amateur",
                "result": 5,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/alea200.png"
            },
            {
                "firstName": "Sarah",
                "lastName": "Nowak",
                "rank": "Amateur",
                "result": 4,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/sarah200.png"
            },
            {
                "firstName": "Colleen",
                "lastName": "Donovan",
                "rank": "Amateur",
                "result": 3,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/collen200.png"
            },
            {
                "firstName": "Ariana",
                "lastName": "Mafi",
                "rank": "Amateur",
                "result": 3,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/mafi200.png"
            },
            {
                "firstName": "Mackenzie",
                "lastName": "Gaddy",
                "rank": "Amateur",
                "result": 5.5,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/gaddy200.png"
            },
            {
                "firstName": "Derek",
                "lastName": "Allen",
                "rank": "Amateur",
                "result": 5,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/derek200.png"
            },
            {
                "firstName": "Kelsey",
                "lastName": "Sampson",
                "rank": "Amateur",
                "result": 4,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/kelsey200.png"
            },
            {
                "firstName": "John",
                "lastName": "Akers",
                "rank": "Amateur",
                "result": 6,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018Amatuer200/john200.png"
            },
            {
                "firstName": "Johnny",
                "lastName": "Esteban",
                "rank": "Professional",
                "result": 6,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018pros200/johnny200.png"
            },
            {
                "firstName": "Jeffery",
                "lastName": "Harrell",
                "rank": "Professional",
                "result": 6,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018pros200/jeff200.png"
            },
            {
                "firstName": "Matt",
                "lastName": "Kelly",
                "rank": "Professional",
                "result": 10,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018pros200/kelly200.png"
            },
            {
                "firstName": "Matt",
                "lastName": "Dioso",
                "rank": "Professional",
                "result": 4,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018pros200/matieu200.png"
            },
            {
                "firstName": "Aidan",
                "lastName": "Earle",
                "rank": "Professional",
                "result": "DQ (7)",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018pros200/aiden200.png"
            },
            {
                "firstName": "Will",
                "lastName": "Cadra",
                "rank": "Professional",
                "result": 8,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018pros200/will200.png"
            },
            {
                "firstName": "Jaybee",
                "lastName": "Ragudo",
                "rank": "Professional",
                "result": 7,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2018pros200/jaybee200.png"
            }
        ]
    },
    {
        "year": 2019,
        "food": "Pizza Rolls",
        "title": "Totino's Throwdown",
        "video": "https://www.youtube.com/embed/W9rzDrwubG0",
        "food_img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/foods/pizza_roll_resized.jpg",
        "professional_winner": "Jimmy Esteban",
        "amateur_winner": "Valerie Yuryk",
        "event_poster": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/event_posters/GS2BigBOIPromo.jpg",
        "logo": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/logos/GS2_logo_crop.png",
        "desc": "<orange>June 8th</orange> - Back by popular demand, Gullet Stuffer returned to the backyard. This time with a new item on the menu: <orange>Pizza Rolls</orange>. The Amateur field (featuring five newcomers) pushed themselves to the limit; as A back-and-forth battle between Brant Criswell and <orange>Valerie Yuryk</orange> ended with Val on top of the podium.\\n\\nThe sun went down and the lights got bright as the Professionals took center-stage in front of an estimated crowd of 100. A three-way battle between Max Mendola, <orange>Jimmy Esteban</orange>, and Asher Rudyan ended with Max and Jimmy locked in a <orange>tie at 68</orange>. The two titans were prepared to call it a draw, but a rabid crowd demanded a conclusion, triggering a five roll eat-off per the Rules and Regulations. After some deep breathing and encouragement from the fans, Esteban stood alone as the Gullet Stuffer II grand champion.",
        "competitors": [
            {
                "firstName": "Valerie",
                "lastName": "Yuryk",
                "rank": "Amateur",
                "result": 57,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/val200.png"
            },
            {
                "firstName": "Brant",
                "lastName": "Criswell",
                "rank": "Amateur",
                "result": 55,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/brant200.png"
            },
            {
                "firstName": "Quinn",
                "lastName": "Madsen",
                "rank": "Amateur",
                "result": 46,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/quinn200.png"
            },
            {
                "firstName": "Kelsey",
                "lastName": "Sampson",
                "rank": "Amateur",
                "result": 38,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/kelsey200.png"
            },
            {
                "firstName": "Matt",
                "lastName": "Dioso",
                "rank": "Amateur",
                "result": 37,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/matt200.png"
            },
            {
                "firstName": "Tom",
                "lastName": "Buchanan",
                "rank": "Amateur",
                "result": 35,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/tom200.png"
            },
            {
                "firstName": "Angel",
                "lastName": "See",
                "rank": "Amateur",
                "result": 32,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/angel200.png"
            },
            {
                "firstName": "Cody",
                "lastName": "Coryell",
                "rank": "Amateur",
                "result": 30,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/cody200.png"
            },
            {
                "firstName": "Ariana",
                "lastName": "Mafi",
                "rank": "Amateur",
                "result": 30,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019ams200/mafi200.png"
            },
            {
                "firstName": "Jimmy",
                "lastName": "Esteban",
                "rank": "Professional",
                "result": "68 (+5)",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/jimmy200.png"
            },
            {
                "firstName": "Max",
                "lastName": "Mendola",
                "rank": "Professional",
                "result": "68 (+3)",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/max200.png"
            },
            {
                "firstName": "Asher",
                "lastName": "Rudyan",
                "rank": "Professional",
                "result": 65,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/asher200.png"
            },
            {
                "firstName": "Jaybee",
                "lastName": "Ragudo",
                "rank": "Professional",
                "result": 55,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/jaybee200.png"
            },
            {
                "firstName": "Haiming",
                "lastName": "Kuang",
                "rank": "Professional",
                "result": "52",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/haiming200.png"
            },
            {
                "firstName": "Chyna",
                "lastName": "Bounds",
                "rank": "Professional",
                "result": 51,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/chyna200.png"
            },
            {
                "firstName": "Henry",
                "lastName": "Cromett",
                "rank": "Professional",
                "result": 50,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/henry200.png"
            },
            {
                "firstName": "Will",
                "lastName": "Cadra",
                "rank": "Professional",
                "result": "(DQ) 46",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2019pros200/will200.png"
            }
        ]
    },
    {
        "year": 2021,
        "food": "Soup",
        "title": "Return of the Can",
        "video": "https://www.youtube.com/embed/kot5BXUPZJg",
        "food_img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/foods/soup_resized.jpg",
        "professional_winner": "Carter Burns",
        "amateur_winner": "Mark Bechtel",
        "event_poster": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/event_posters/RealGS3.png",
        "logo": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/logos/GS3_logo.png",
        "desc": "<orange>September 11th</orange> - A long pandemic layoff and a MegaBites web series later... The in-person event returned, this time in a backyard off of 23rd Ave in Seattle's Central District. A mysterious orange <orange>Atlantic brand 'Vegetable' soup</orange> was on the Amateur menu; and a small crowd applauded politely as Mark Bechtel edged out Ben Smith and Stephen Legge in a tight contest.\\n\\nNight fell and the space was lit by an orange glow of the newly revealed Gullet Stuffer neon sign. After a thunderous ovation for MegaBites champion Daniel Herzog, the six Professionals stared down some of the hottest soup the Central District has ever seen. Sweat, steam and screams rained down on rookie <orange>Carter Burns</orange> as he scooped deep into the bottom of his bowl with no regard for his fingers. 74oz of piping hot <orange>Campbell's Chunky Chicken Noodle Soup</orange> later, Carter burned his name into the history books.",
        "competitors": [
            {
                "firstName": "Mark",
                "lastName": "Bechtel",
                "rank": "Amateur",
                "result": "70.5oz",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021ams200/bechtel200.jpg"
            },
            {
                "firstName": "Ben",
                "lastName": "Smith",
                "rank": "Amateur",
                "result": "67.5",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021ams200/bensmith200.jpg"
            },
            {
                "firstName": "Steven",
                "lastName": "Legge",
                "rank": "Amateur",
                "result": "64.5",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021ams200/legge200.jpg"
            },
            {
                "firstName": "Josie",
                "lastName": "Culp",
                "rank": "Amateur",
                "result": "62",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021ams200/josie200.jpg"
            },
            {
                "firstName": "Sarah",
                "lastName": "Leslie",
                "rank": "Amateur",
                "result": "52.5",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021ams200/sarah200.jpg"
            },
            {
                "firstName": "Jeffery",
                "lastName": "Harrell",
                "rank": "Amateur",
                "result": "45",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021ams200/jeffy200.jpg"
            },
            {
                "firstName": "Carter",
                "lastName": "Burns",
                "rank": "Professional",
                "result": "74oz",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021pros200/carter200.jpg"
            },
            {
                "firstName": "Asher",
                "lastName": "Rudyan",
                "rank": "Professional",
                "result": "68.5",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021pros200/asher200.jpg"
            },
            {
                "firstName": "Jared",
                "lastName": "Brandon",
                "rank": "Professional",
                "result": "59.2",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021pros200/jared200.jpg"
            },
            {
                "firstName": "Daniel",
                "lastName": "Herzog",
                "rank": "Professional",
                "result": "57.4",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021pros200/herzog.jpg"
            },
            {
                "firstName": "Henry",
                "lastName": "Cromett",
                "rank": "Professional",
                "result": "46.25",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021pros200/henry200.jpg"
            },
            {
                "firstName": "Jaybee",
                "lastName": "Ragudo",
                "rank": "Professional",
                "result": "37",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2021pros200/jaybee200.jpg"
            }
        ]
    },
    {
        "year": 2022,
        "food": "Dino Nuggets",
        "title": "Prehistoric Pandemonium",
        "video": "https://www.youtube.com/embed/fR5OlKENIUM",
        "food_img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/foods/dino_resized.jpg",
        "professional_winner": "Cameron Goulds",
        "amateur_winner": "Julian Saquic-Ray",
        "event_poster": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/event_posters/GS4.jpg",
        "logo": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/logos/GS4_logo_crop.png",
        "desc": "<orange>July 9th</orange> - A landmark agreement with <orange>Grocery Outlet Bargain Market</orange> swapped backyard for blacktop, as the event entered a new era. Parking lot dreams became reality as Gullet Stuffer IV took center stage at the intersection of MLK and Union. In the first edition of Gullet Stuffer Resolution fan voting, <orange>Dino Chicken Nuggets</orange> were selected as the featured menu item.\\n\\nClad in turquoise, the Amateur group was highlighted by veterans Ariana Mafi and Quinn 'Mad Dog' Madsen, as well as the milestone debut of 8-year-old Dallas. Grocery shoppers looked on in utter confusion and fans roared as <orange>Julian Saquic-Ray</orange> lifted the Amateur trophy to the summer evening sky...\\n\\nThe Professionals featured some firepower, led by veteran Jaybee 'Bone Bold Cheap Costin' Ragudo and defending champ Carter Burns, as well as GSII runner up Max Mendola. Hot from the deep fryer, 351 Dino Chicken Nuggets found a home deep in the stomach of our fearless athletes, but only one could stand alone... Added to the field as a last second alternate, <orange>Cameron Gould-Saltman</orange> earned the nickname <orange>'Mr. Impossible'</orange> and the title of Gullet Stuffer Grand Champion.",
        "competitors": [
            {
                "firstName": "Julian",
                "lastName": "Saquic Ray",
                "rank": "Amateur",
                "result": 42,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/julian200.jpg"
            },
            {
                "firstName": "Quinn",
                "lastName": "Madsen",
                "rank": "Amateur",
                "result": 38,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/quinn200.jpg"
            },
            {
                "firstName": "Steven",
                "lastName": "Legge",
                "rank": "Amateur",
                "result": 36,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/legge.jpg"
            },
            {
                "firstName": "Derek",
                "lastName": "Allen",
                "rank": "Amateur",
                "result": 32,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/derek200.jpg"
            },
            {
                "firstName": "Alex",
                "lastName": "Finestead",
                "rank": "Amateur",
                "result": 32,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/alexf200.jpg"
            },
            {
                "firstName": "Andrea",
                "lastName": "Entz",
                "rank": "Amateur",
                "result": 31,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/whatsherface200.jpg"
            },
            {
                "firstName": "Jesse",
                "lastName": "Warren",
                "rank": "Amateur",
                "result": 30,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/jesse200.jpg"
            },
            {
                "firstName": "Ariana",
                "lastName": "Mafi",
                "rank": "Amateur",
                "result": 27,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/mafi200.jpg"
            },
            {
                "firstName": "Dallas",
                "lastName": "",
                "rank": "Amateur",
                "result": 18,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022ams200/dallas.jpg"
            },
            {
                "firstName": "Cameron",
                "lastName": "Gould",
                "rank": "Professional",
                "result": 56,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/cameron200.jpg"
            },
            {
                "firstName": "Max",
                "lastName": "Mendola",
                "rank": "Professional",
                "result": 48,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/max200.jpg"
            },
            {
                "firstName": "John",
                "lastName": "Akers",
                "rank": "Professional",
                "result": 47,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/johnakers200.jpg"
            },
            {
                "firstName": "Zach",
                "lastName": "Bach",
                "rank": "Professional",
                "result": 40,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/zach200.jpg"
            },
            {
                "firstName": "Asher",
                "lastName": "Rudyan",
                "rank": "Professional",
                "result": 37,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/asher200.jpg"
            },
            {
                "firstName": "Jaybee",
                "lastName": "Ragudo",
                "rank": "Professional",
                "result": 33,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/jaybee200.jpg"
            },
            {
                "firstName": "Carter",
                "lastName": "Burns",
                "rank": "Professional",
                "result": 32,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/carter200.jpg"
            },
            {
                "firstName": "Alex",
                "lastName": "De Paz",
                "rank": "Professional",
                "result": 25,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/alexdp200.jpg"
            },
            {
                "firstName": "Jared",
                "lastName": "Brandon",
                "rank": "Professional",
                "result": 20,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/jared200.jpg"
            },
            {
                "firstName": "Larry",
                "lastName": "Roze",
                "rank": "Professional",
                "result": 13,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2022pros200/larry200.jpg"
            }
        ]
    },
    {
        "year": 2023,
        "food": "Eggo Waffles",
        "title": "Eggomania",
        "professional_winner": "Dee Street Domenica",
        "video": "https://www.youtube.com/embed/Up799qwivC8?si=6f8_bBZ3mDlMIrHl",
        "food_img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/foods/waffle_resized.png",
        "amateur_winner": "Mark Bechtel",
        "event_poster": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/event_posters/GS5.jpg",
        "logo": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/logos/GS5_logo.png",
        "desc": "<orange>July 8th</orange> - Cries of 'Leggo my Eggo!' rang throughout the neighborhood, as a wave of waffles overtook the Central District. Pirates vs. Children, sludge rock boxing, and extreme Eggo sprinters got the party started early.\\n\\nDonning bright pink T-shirts, a new crop of wild Amateurs set out to challenge four seasoned returnees. An aggressive start by Parisa 'The Guzzler' Shahbaz wow'd the crowd; but down the stretch it was <orange>Mark 'Big Soup' Bechtel</orange> who powered his way to victory by a single waffle.\\n\\nThe most decorated Professional bracket in modern history featured two former champions and some beefy resumes. Halfway through the ten minute timer, one butter baron took flight; Domenica, aka <orange>'Dee Street'</orange> left the field behind, finishing with a stunning 36 Eggo Waffles, 13 more than her closest competitor. A new star has risen...",
        "competitors": [
            {
                "firstName": "Mark",
                "lastName": "Bechtel",
                "rank": "Amateur",
                "result": 16,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/markb.jpg"
            },
            {
                "firstName": "Luke",
                "lastName": "Sorvik",
                "rank": "Amateur",
                "result": 15,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/lukesorvik.jpg"
            },
            {
                "firstName": "Stephen",
                "lastName": "Legge",
                "rank": "Amateur",
                "result": 15,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/legge.jpg"
            },
            {
                "firstName": "A Block",
                "lastName": "of Cheese",
                "rank": "Amateur",
                "result": 15,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/cheez.jpg"
            },
            {
                "firstName": "Addison",
                "lastName": "Halpin Higman",
                "rank": "Amateur",
                "result": 14,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/addisonHH.jpg"
            },
            {
                "firstName": "Parisa",
                "lastName": "Shabaz",
                "rank": "Amateur",
                "result": 13,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/parpar.jpg"
            },
            {
                "firstName": "The",
                "lastName": "Maskali",
                "rank": "Amateur",
                "result": 13,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/maskali.jpg"
            },
            {
                "firstName": "Becca",
                "lastName": "Reilly",
                "rank": "Amateur",
                "result": 12,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/beccar.jpg"
            },
            {
                "firstName": "Quinn",
                "lastName": "Madsen",
                "rank": "Amateur",
                "result": 9,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/quinnmad.jpg"
            },
            {
                "firstName": "Ariana",
                "lastName": "Mafi",
                "rank": "Amateur",
                "result": 9,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/amateurs/mafi.jpg"
            },
            {
                "firstName": "Dee",
                "lastName": "Street",
                "rank": "Professional",
                "result": 36,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/Dee.jpg"
            },
            {
                "firstName": "Kyle",
                "lastName": "Skow",
                "rank": "Professional",
                "result": 23,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/KyleSkow.jpg"
            },
            {
                "firstName": "Carter",
                "lastName": "Burns",
                "rank": "Professional",
                "result": 22,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/carter.jpg"
            },
            {
                "firstName": "Bruce",
                "lastName": "Morris",
                "rank": "Professional",
                "result": 20,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/bruce.png"
            },
            {
                "firstName": "Cameron",
                "lastName": "Gould",
                "rank": "Professional",
                "result": 19,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/cameron.jpg"
            },
            {
                "firstName": "Julian",
                "lastName": "Saquic Ray",
                "rank": "Professional",
                "result": 18,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/julian.jpg"
            },
            {
                "firstName": "Ryan",
                "lastName": "Trelstad",
                "rank": "Professional",
                "result": 17,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/chefboy.jpg"
            },
            {
                "firstName": "Jaybee",
                "lastName": "Ragudo",
                "rank": "Professional",
                "result": 15,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/jayb.jpg"
            },
            {
                "firstName": "Kevin",
                "lastName": "Yi",
                "rank": "Professional",
                "result": 14,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/Yi.jpg"
            },
            {
                "firstName": "Greggo",
                "lastName": "The Gregarious",
                "rank": "Professional",
                "result": 12,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/GSVthumbnails/pros/greggo.jpg"
            }
        ]
    },
    {
        "year": 2024,
        "food": "Mini Donuts",
        "title": "Mini Donut Massacre",
        "professional_winner": "Dee Street Domenica",
        "video": "https://www.youtube.com/embed/RYolWQluSbQ?si=Gh1ueuOaWP6MSl4Y",
        "food_img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/foods/waffle_resized.png",
        "amateur_winner": "George Tecero",
        "event_poster": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS6/GS6_event_poster.jpeg",
        "logo": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/logos/gs6_logo.png",
        "desc": "<orange>July 13th</orange> - The thunderous drumbeat of Inochi Taiko beckoned from the piping hot blacktop, as fans settled in to watch the sweetest edition of Gullet Stuffer yet.\\n\\nRocking a delightful shade of lavender, the Amateurs gave it their all in a performance that featured a cheese shower, a pickle parasol, and five flavors of mini donuts. Despite another valiant effort by 4-time athlete Stephen Legge, it was <orange>'King George' Tecero</orange> who was crowned the 2024 Amateur champ.\\n\\nEleven more athletes made their way through the crowd from behind the El Gran Taco Truck, taking their place in front of another packed out parking lot. Sarah 'Babs' Rodriguez came out of the gate on fire, as the Amateur high mark of 45 was quickly burnt to a crisp. A three way battle emerged between Sarah, Juan 'More Bite' and Dee Street, and down to the wire it went! After the plume of powder, glaze and sprinkles subsided, it was a <orange>Dee Street</orange> repeat, as she edged out Juan More Bite by a mere two minis!",
        "competitors": [
            {
                "firstName": "George",
                "lastName": "Tecero",
                "rank": "Amateur",
                "result": 45,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/george_cropped.jpg"
            },
            {
                "firstName": "Stephen",
                "lastName": "Legge",
                "rank": "Amateur",
                "result": 37,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/stevenLegge_cropped.jpg"
            },
            {
                "firstName": "Alec",
                "lastName": "Betancur",
                "rank": "Amateur",
                "result": 35,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/alecB_cropped.jpg"
            },
            {
                "firstName": "Karisa",
                "lastName": "Gurtiza",
                "rank": "Amateur",
                "result": 32,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/karisa_cropped.jpg"
            },
            {
                "firstName": "Ellie",
                "lastName": "Masters",
                "rank": "Amateur",
                "result": 30,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/elliem_cropped.jpg"
            },
            {
                "firstName": "Quinn",
                "lastName": "Madsen",
                "rank": "Amateur",
                "result": 30,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/quinn_cropped.jpg"
            },
            {
                "firstName": "Jun-Yea",
                "lastName": "Wu",
                "rank": "Amateur",
                "result": 28,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/jun_cropped.jpg"
            },
            {
                "firstName": "Parisa",
                "lastName": "Shahbaz",
                "rank": "Amateur",
                "result": 26,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/theguzzler_cropped.jpg"
            },
            {
                "firstName": "Rosa",
                "lastName": "Mestas",
                "rank": "Amateur",
                "result": 15,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/rosa_cropped.jpg"
            },
            {
                "firstName": "A Block",
                "lastName": "of Cheeze",
                "rank": "Amateur",
                "result": "31 (DQ)",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20amateurs/blockofcheeze_cropped.jpg"
            },
            {
                "firstName": "Dee",
                "lastName": "Street",
                "rank": "Professional",
                "result": 103,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/deestreet_cropped.jpg"
            },
            {
                "firstName": "Juan",
                "lastName": "Rodriguez",
                "rank": "Professional",
                "result": 101,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/juan_cropped.jpg"
            },
            {
                "firstName": "Sarah",
                "lastName": "Rodriguez",
                "rank": "Professional",
                "result": 91,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/sarahrodriguez_cropped.jpg"
            },
            {
                "firstName": "Sam",
                "lastName": "Shirley",
                "rank": "Professional",
                "result": 56,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/samshirley_cropped.jpg"
            },
            {
                "firstName": "Odin",
                "lastName": "",
                "rank": "Professional",
                "result": 45,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/Odin_cropped.jpg"
            },
            {
                "firstName": "Dan",
                "lastName": "W",
                "rank": "Professional",
                "result": 37,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/danw_cropped.jpg"
            },
            {
                "firstName": "Matt",
                "lastName": "Park",
                "rank": "Professional",
                "result": 31,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/mattpark_cropped.jpg"
            },
            {
                "firstName": "Mark",
                "lastName": "Bechtel",
                "rank": "Professional",
                "result": 30,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/markB_cropped.jpg"
            },
            {
                "firstName": "Tyler",
                "lastName": "Engleman",
                "rank": "Professional",
                "result": 30,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/tylerE_cropped.jpg"
            },
            {
                "firstName": "Jason",
                "lastName": "Cole",
                "rank": "Professional",
                "result": 20,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/jasoncole_cropped.jpg"
            },
            {
                "firstName": "Ryan",
                "lastName": "Trelstad",
                "rank": "Professional",
                "result": "41 (DQ)",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2024%20pros/chefboy_cropped.jpg"
            }
        ]
    },
    {
        "year": 2025,
        "food": "Gyoza",
        "title": "Going Gyoza",
        "professional_winner": "Naader 'Freak Eating' Reda",
        "video": "https://www.youtube.com/embed/rjAA-JpOcfs?si=ONlSpeXy-UmXL4N1",
        "food_img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/foods/waffle_resized.png",
        "amateur_winner": "Jessamyn Reichmann",
        "event_poster": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/gs7_poster-1.jpg",
        "logo": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/logos/gs7_logo.png",
        "desc": "<orange>July 12th</orange> - 'G-Y... O-Z-A!' Another packed out parking lot was on hand to watch a bite sized battle for vegetarian dumpling supremacy.\\n\\nThe Amateur group was highlighted by five-time athletes Stephen 'Leggend' Legge and Quinn 'Rad Dog' Madsen, Grocery Outlet employees Marlon and Jason 'Mr. Terrific' Cole, and the surprise return of 11-year-old Dallas. Fans tried with all their might to urge their favorites to the podium, but it was Seattle's Sweetheart, <orange>Jessamyn Reichmann</orange> who jumped out to a commanding lead, smiling, dancing and vibing her way to a dominant victory by the margin of 14 delicious gyoza!\\n\\nIn the Professional Category, the field was wide-open, as the Top 3 finishers of 2024 were all absent. Who would fill their void? Rookie Miles 'Ahead' Zoltak made his case as he set off like a munching missile, swallowing whole gyozas with nary a bite. As he eclipsed the century mark with multiple minutes to spare, his stomach began to seize and what looked to be a victory lap turned into a battle of willpower between man and belly. All the while, <orange>Naader 'Freak Eating' Reda</orange> kept his eyes on the prize, gaining steady ground before making a last gasp effort, stuffing his gullet full of dumplings as the buzzer sounded. Upon further review, in one of the closes finishes in contest history, fans saw <orange>'The Freak'</orange> crowned as the true Gyoza GOAT of Gullet Stuffer VII, by one singular gyoza!",
        "competitors": [
            {
                "firstName": "Jessamyn",
                "lastName": "Reichmann",
                "rank": "Amateur",
                "result": 74,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/jesscrop.png"
            },
            {
                "firstName": "Marlon",
                "lastName": "",
                "rank": "Amateur",
                "result": 60,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/marloncrop.png"
            },
            {
                "firstName": "Josh",
                "lastName": "Ungurait",
                "rank": "Amateur",
                "result": 56,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/joshcrop.png"
            },
            {
                "firstName": "Stephen",
                "lastName": "Legge",
                "rank": "Amateur",
                "result": 53,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/leggecrop.png"
            },
            {
                "firstName": "Kate",
                "lastName": "Schageman",
                "rank": "Amateur",
                "result": 50,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/katecrop.png"
            },
            {
                "firstName": "Nour",
                "lastName": "Benmohamed",
                "rank": "Amateur",
                "result": 43,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/nourcrop.png"
            },
            {
                "firstName": "Parisa",
                "lastName": "Shahbaz",
                "rank": "Amateur",
                "result": 43,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/parcrop.png"
            },
            {
                "firstName": "A Block",
                "lastName": "of Cheeze",
                "rank": "Amateur",
                "result": 38,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/cheezcrop.png"
            },
            {
                "firstName": "Quinn",
                "lastName": "Madsen",
                "rank": "Amateur",
                "result": 36,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/quinncrop.png"
            },
            {
                "firstName": "Dallas",
                "lastName": "",
                "rank": "Amateur",
                "result": 32,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/dallascrop.png"
            },
            {
                "firstName": "Jason",
                "lastName": "Cole",
                "rank": "Amateur",
                "result": 26,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20amateurs/jcolecrop.png"
            },
            {
                "firstName": "Naader",
                "lastName": "Reda",
                "rank": "Professional",
                "result": 116,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/freakcrop.png"
            },
            {
                "firstName": "Miles",
                "lastName": "Zoltak",
                "rank": "Professional",
                "result": 115,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/milescrop.png"
            },
            {
                "firstName": "Sam",
                "lastName": "Shirley",
                "rank": "Professional",
                "result": 94,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/samcrop.png"
            },
            {
                "firstName": "Jeremy",
                "lastName": "Katz",
                "rank": "Professional",
                "result": 89,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/katzcrop.png"
            },
            {
                "firstName": "Julian",
                "lastName": "Saquic Ray",
                "rank": "Professional",
                "result": 80,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/juliancrop.png"
            },
            {
                "firstName": "Kenney",
                "lastName": "Tran",
                "rank": "Professional",
                "result": 73,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/kenneycrop.png"
            },
            {
                "firstName": "Oden",
                "lastName": "",
                "rank": "Professional",
                "result": 70,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/odencrop.png"
            },
            {
                "firstName": "Crosby",
                "lastName": "Schultz",
                "rank": "Professional",
                "result": 69,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/crosbycrop.png"
            },
            {
                "firstName": "Michael",
                "lastName": "Pascua",
                "rank": "Professional",
                "result": 67,
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/pascuacrop.png"
            },
            {
                "firstName": "Conner",
                "lastName": "Deal",
                "rank": "Professional",
                "result": "39 (DQ)",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/AthleteSquares/2025%20pros/dealcrop.png"
            }
        ]
    }
]